var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10H0C0 4.486 4.486 0 10 0C13.028 0 15.504 1.408 17 2.986V0H19V7H12V5H16.093C15.201 3.767 13.049 2 10 2C5.589 2 2 5.589 2 10ZM10 18C6.951 18 4.799 16.233 3.907 15H8V13H1V20H3V17.014C4.496 18.592 6.972 20 10 20C15.514 20 20 15.514 20 10H18C18 14.411 14.411 18 10 18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateM);
export default __webpack_public_path__ + "static/media/update-m.c962804f4f4a3c9792b21b819903698b.svg";
export { ForwardRef as ReactComponent };